import type { SpatialRectangle } from "../geometry/SpatialRectangle"
import type { BasePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_media
export type PlotMedia = {
  func: PlotFunction.PLOT_MEDIA
  crop_position: SpatialRectangle
  media_position: SpatialRectangle
  page: string
} & BasePlotObject
